import { useState, useEffect } from "react";
import { InvoiceStatsData } from "../../@types";
import { getInvoiceStats } from "../../backend-services";

interface ErrorType {
  message?: string;
}

export function useInvoiceStatsData(startDate: Date, endDate: Date) {
  const [invoiceData, setInvoiceData] = useState<InvoiceStatsData | null>(null);
  const [error, setError] = useState<ErrorType | null>(null);
  const fetchData = async () => {
    try {
      const response = await getInvoiceStats(
        startDate.toISOString(),
        endDate.toISOString()
      );
     
      setInvoiceData(response);
      setError(null);
    } catch (error) {
      setError({ message: "Failed to fetch invoice statistics" });
      setInvoiceData(null);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return { invoiceData, error };
}
